var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.5,
    height: 13.5,
    x: 0.75,
    y: 9.75,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.75 9.75V6a5.25 5.25 0 1 1 10.5 0v3.75M9 15v3"
  }))));
};
export default SvgLock;